var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGolfStick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "28px",
    viewBox: "0 0 19 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "golf-stick copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirmation-Flow",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "JetOS-light/v3/-Bookings/Confirmation-Flow/02.2-Flight-Page-View-Trip-Details-Add-Crew",
    transform: "translate(-1792.000000, -2393.000000)",
    fill: "#19C0FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CONTENT",
    transform: "translate(330.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(45.000000, 555.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Passengers-info",
    transform: "translate(0.000000, 1270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Luggage-",
    transform: "translate(24.000000, 413.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Golf-Club",
    transform: "translate(1106.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "luggages",
    transform: "translate(287.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "golf-stick-copy",
    transform: "translate(0.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4666667,15.4372825 L15.4666667,14.6281592 C15.4666667,14.1875058 15.10848,13.8302596 14.6666667,13.8302596 L13.3333333,13.8302596 L13.3333333,11.1705943 L16.2666667,11.1705943 C17.5900267,11.1705943 18.6666667,10.096781 18.6666667,8.77689549 C18.6666667,7.45700999 17.5900267,6.38319672 16.2666667,6.38319672 L14.6666667,6.38319672 C13.0492267,6.38319672 11.7333333,7.69563516 11.7333333,9.30882855 L11.7333333,13.8302596 L10.1333333,13.8302596 L10.1333333,4.78739754 L13.0666667,4.78739754 C14.3900267,4.78739754 15.4666667,3.71358427 15.4666667,2.39369877 C15.4666667,1.07381327 14.3900267,0 13.0666667,0 L11.4666667,0 C9.84922667,0 8.53333333,1.31243844 8.53333333,2.92563183 L8.53333333,13.8302596 L6.93333333,13.8302596 L6.93333333,5.05336407 C6.93333333,3.44017068 5.61744,2.12773224 4,2.12773224 L2.4,2.12773224 C1.07664,2.12773224 0,3.20154551 0,4.52143101 C0,5.84131651 1.07664,6.91512978 2.4,6.91512978 L5.33333333,6.91512978 L5.33333333,13.8302596 L4,13.8302596 C3.55818667,13.8302596 3.2,14.1875058 3.2,14.6281592 L3.2,15.4260587 L4.53333333,15.4260587 C6.73893333,15.4260587 8.53333333,17.2157475 8.53333333,19.4155567 L8.53333333,23.1390881 C8.53333333,24.4589736 7.45669333,25.5327869 6.13333333,25.5327869 L3.2,25.5327869 L3.2,26.4370731 C3.2,26.8777264 3.55818667,27.2349727 4,27.2349727 L14.6666667,27.2349727 C15.10848,27.2349727 15.4666667,26.8777264 15.4666667,26.4370731 L15.4666667,24.4689208 L16.2666667,24.4689208 C17.5900267,24.4689208 18.6666667,23.3951075 18.6666667,22.075222 L18.6666667,18.8836236 C18.6666667,17.0666999 17.25392,15.5737234 15.4666667,15.4372825 Z M17.0666667,22.075222 C17.0666667,22.5151838 16.7077867,22.8731216 16.2666667,22.8731216 L15.4666667,22.8731216 L15.4666667,17.0411671 C16.3700267,17.1706396 17.0666667,17.9473683 17.0666667,18.8836236 L17.0666667,22.075222 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.03825137,23.0920555 L7.03825137,19.4670029 C7.03825137,18.1820254 5.94003934,17.136612 4.59016393,17.136612 L2.95810565,17.136612 C2.50743995,17.136612 2.1420765,17.4844099 2.1420765,17.913409 L2.1420765,23.0920555 C2.1420765,23.5210546 2.50743995,23.8688525 2.95810565,23.8688525 L6.22222222,23.8688525 C6.67288792,23.8688525 7.03825137,23.5210546 7.03825137,23.0920555 Z",
    id: "Path"
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfStick);
export default __webpack_public_path__ + "static/media/golf-stick.f76dc0c9.svg";
export { ForwardRef as ReactComponent };